import { IGraphNode } from "@excitare/cli-config";
import { IServiceEnv } from "@excitare/cli-types";
import { PubSubEventData, PubSubEvents } from "@excitare/pubsub";
import { sign } from "jsonwebtoken";

import { pubSubServer } from "..";
import { ServiceInstance } from "../build";

import { localServices } from "./services";

export class LocalService {
  currentData: PubSubEventData.ClientInfo;

  private readonly secret: string | null;

  constructor(
    readonly service: IGraphNode,
    readonly instance: ServiceInstance,
    private readonly preferredPort: number | undefined,
    readonly _io: SocketIO.Server,
    private readonly env: IServiceEnv,
    private readonly inspect: boolean
  ) {
    this.secret = null;
    // Don't use secrets in dev
    // this.service.publicFacingPath == null ? service.name : undefined;

    const token =
      this.secret != null
        ? sign(
            {
              name: this.service.name
            },
            this.secret
          )
        : undefined;

    this.currentData = localServices.updateServiceData(service.name, {
      name: service.name,
      token,
      host: "http://localhost"
    });

    pubSubServer().on(PubSubEvents.ClientInfo, data => {
      if (data.name === service.name) {
        this.currentData = localServices.updateServiceData(
          service.name,
          {
            port: data.port,
            host: "http://localhost:" + data.port
          },
          true
        );
      }
    });
  }

  private canStart: boolean = false;

  async boot(): Promise<PubSubEventData.ClientInfo> {
    this.canStart = true;
    await this.doStart();
    return this.currentData;
  }

  async stop() {
    this.instance.stop();
    this.instance.stopBuild();
  }

  private async doStart() {
    if (!this.canStart) {
      return; // Don't start until allowed to boot
    }
    const title = `Service start: ${this.service.name}`;
    console.time(title);
    await this.instance.start(
      this.secret,
      this.preferredPort,
      this.currentData.publicFacingUrl,
      this.service.children
        .map(el => localServices.byName(el.name))
        .filter((el): el is PubSubEventData.ClientInfo => el != null),
      this.env,
      this.inspect
    );
    console.timeEnd(title);
  }

  async watch() {
    let isResolved = false;
    await new Promise((resolve, reject) => {
      this.instance.watch(
        () => {
          this.instance.stop();
        },
        errors => {
          if (errors != null) {
            for (const error of errors) {
              if (error != null) {
                console.log(error);
              }
            }
          }
          const promise = this.doStart();
          promise.catch(err => console.error(err));
          if (!isResolved) {
            isResolved = true;
            promise.then(() => resolve(), reject);
          }
        }
      );
    });
  }
}
